import {SHELL_PROTOCOL_OPERATIONS_NS} from '../shell-protocol-namespace.const';
import {ProtocolCommand} from '../../../service-model/protocol-command.interface';

export class ReplaceOrder implements ProtocolCommand {
  constructor(
    public readonly strategyId: string,
    public readonly orderId: string,
    public readonly orderPrice?: number,
    public readonly qty?: number
  ) {
  }

  getOperationName(): string {
    return `${SHELL_PROTOCOL_OPERATIONS_NS}.ReplaceOrder`;
  }
}
